module.exports = __webpack_public_path__ + "img/merkle-ch-pix.3ede1f09.jpg";